import { render, staticRenderFns } from "./file-detail.vue?vue&type=template&id=304cca50&"
import script from "./file-detail.vue?vue&type=script&lang=js&"
export * from "./file-detail.vue?vue&type=script&lang=js&"
import style0 from "./file-detail.vue?vue&type=style&index=0&id=304cca50&prod&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports